export default class PlatformService {
    static isWeb = false;
}